/** Created by azhou on 2019/3/14.*/
<template>
  <div>
    <group-discount-list v-if="isGroup && !storeId"/>
    <store-discount-lists v-else/>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import GroupDiscountList from './GroupDiscountList'
  import StoreDiscountLists from './StoreDiscountLists'

  export default {
    name: 'GroupDiscountBus',
    components: { StoreDiscountLists, GroupDiscountList },
    computed: {
      ...mapGetters(['storeInfo','isGroup']),
      storeId() { return this.$route.query.store },
    }
  }
</script>
